export default __webpack_public_path__ + "static/media/Develope.48a8617e.svg";